export default __webpack_public_path__ + "static/media/$5.6ae54675.png";